import React, { useContext, useEffect } from "react";
import {
  Box,
  Dialog,
  Button,
  IconButton,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { observer } from "mobx-react-lite";
import CloseIcon from "@mui/icons-material/Close";
import GuiasRastreo from "../components/GuiasRastreo";
import ActualizacionesTracker from "../components/ActualizacionesTracker";
import InfoGeneralEnvios from "../../components/usuarios/InfoGeneralEnvios";
import { RootStoreContext } from "../../app/store/root";
import {
  EnumCatalogosEncabezado,
  EnumStatusShipmentString,
} from "../../shared/Enumerables";
import { toJS } from "mobx";

export const ModalDetalles = ({ onClose }) => {
  const rootStore = useContext(RootStoreContext);

  const { entity } = rootStore.shipmentStore;

  const { consultarComprobanteArchivo: _consultarComprobanteArchivo } =
    rootStore.embarqueStore;

  const [estatusEnvios, setEstatusEnvios] = React.useState([]);

  const { getValoresCatalogo } = rootStore.catalogosStore;

  const getValoresCatalogoEstatus = async () => {
    let resp = await getValoresCatalogo(EnumCatalogosEncabezado.EstatusEnvios);
    if (resp != null) setEstatusEnvios(resp);
  };

  useEffect(() => {    
    getValoresCatalogoEstatus();
  }, []);

  const consultarComprobanteArchivo = async (event) => {
    event.preventDefault();
    rootStore.logisticBackdropStore.openLoading();
    await _consultarComprobanteArchivo(entity.idEmbarque);
    rootStore.logisticBackdropStore.closeLoading();
  };

  return (
    <div>
      <DialogTitle>
        Detalles del envio #{entity?.numeroGuia}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box>
          <Box>
            <InfoGeneralEnvios tipo={1} />
          </Box>
          <Box mt={1}>
            <GuiasRastreo />
          </Box>
          <Box mt={1}>
            <ActualizacionesTracker tipo={"envios"} />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions variant="paddi">
        {(
          estatusEnvios.find((a) => a.id === entity?.idEstatus)?.valor ?? ""
        ).toUpperCase() === EnumStatusShipmentString.Entregado && (
          <Button
            onClick={(e) => consultarComprobanteArchivo(e)}
            variant="contained"
            color="secondary"
            sx={{ color: "#fff" }}
          >
            Ver comprobante
          </Button>
        )}
        <Button onClick={onClose} variant="contained">
          Cerrar
        </Button>
      </DialogActions>
    </div>
  );
};

export default observer(ModalDetalles);
